module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-21.27915454.png";